import React, { useState } from 'react';
import { Button, Collapse, Typography, Box  } from '@mui/material';

function ButtonTextHide({buttonText, hideText, handleChangeOption, justInfo}) {
  const [open, setOpen] = useState(false);

  const toggleVisibility = () => {
    setOpen(!open);
  };

  return (
    <>
    <Box display="flex" alignItems="center">

      <Button 
        variant="contained" 
        onClick={toggleVisibility}
        sx={{ 
            minWidth: 200, // Establecer un ancho mínimo para el botón
            whiteSpace: 'normal',  // Permitir que el texto se divida en varias líneas si es necesario
            wordBreak: 'break-word', // Controlar el salto de palabras si el texto es largo
            padding: '8px 16px' // Ajustar el padding para que el botón sea más flexible
          }}
      >
        {justInfo ? buttonText : (open ? 'Cerrar' : `¿Qué hago en ${buttonText}?`)}
      </Button>

      <Collapse in={open} sx={{ marginLeft: 2 }}>
        <Box
          sx={{
            backgroundColor: 'grey.800',  // Color de fondo
            padding: 1,                    // Espaciado interno
            borderRadius: 1,               // Bordes redondeados
          }}
        >
          <Typography variant="body1" color={'white'} align="left">
              {hideText}
          </Typography>

          {!justInfo ? <Button 
            variant="contained" 
            onClick={() => handleChangeOption(buttonText)}
            sx={{ 
                minWidth: 20, // Establecer un ancho mínimo para el botón
                whiteSpace: 'normal',  // Permitir que el texto se divida en varias líneas si es necesario
                wordBreak: 'break-word', // Controlar el salto de palabras si el texto es largo
              }}
            >
            ir
          </Button> : <></>}

        </Box>

      </Collapse>

    </Box>
    </>
  );
}

export default ButtonTextHide;